<template>
  <header class="tw-flex tw-justify-center tw-item-center tw-relative">
    <KycCommonGoBack @go-back="$emit('goBack')"
      class="tw-absolute tw-top-1/2 tw-translate-y-[-50%] tw-left-0 tw-flex" />
    <div>
      <h3 class="tw-text-2xl sm:tw-text-3xl md:tw-text-4xl lg:tw-text-[45px] tw-font-black">
        {{ title }}
        <span v-if="subtitle" class="tw-hidden md:tw-inline">- {{ subtitle }}</span>
      </h3>
      <h6 v-if="subtitle" class="tw-text-lg md:tw-text-xl md:tw-hidden tw-text-center">
        {{ subtitle }}
      </h6>
    </div>
  </header>
  <div class=" tw-flex tw-justify-center tw-pt-4 md:tw-pt-8" v-if="showLocale">
    <div class="tw-join">
      <NuxtLink :to="switchLocalePath('en')" replace
        class="tw-join-item tw-btn tw-btn-xs tw-btn-outline tw-border [--btn-focus-scale:1] [--fallback-bc:#DED0B8] " :class="{
          'tw-btn-active': !['zh_Hans','zh_Hant'].includes(locale)
        }">
        <SvgoCommonEn class=" tw-w-4 tw-rounded-full" /> EN
      </NuxtLink>
      <NuxtLink :to="switchLocalePath('zh_Hans')" replace
        class="tw-join-item tw-btn tw-btn-xs tw-btn-outline tw-border  [--btn-focus-scale:1] [--fallback-bc:#DED0B8] " :class="{
          'tw-btn-active': ['zh_Hans','zh_Hant'].includes(locale)
        }">
        <SvgoCommonCn class="tw-w-4 tw-rounded-full" /> 中文
        <!-- [--fallback-bc:theme(colors.primary)] -->
      </NuxtLink>
    </div>
  </div>
</template>
<script setup lang="ts">
const switchLocalePath = useSwitchLocalePath()
const { locale } = useI18n()
defineProps<{ title: string; subtitle?: string,showLocale?: boolean}>()
defineEmits<{
  (e: 'goBack'): void
}>()
</script>
